let parallaxCursor = function(selector) {
  if (!document.querySelector(selector)) {
    return
  }
  let wrapper = document.querySelector(selector),
      elements = wrapper.querySelectorAll('.layer');
  document.querySelector('header').addEventListener('mousemove', e => {
    let mouseX = e.clientX - (document.documentElement.clientWidth / 2),
        mouseY = e.clientY - (document.documentElement.clientHeight / 2);
    elements.forEach(item => {
      let depth = item.getAttribute('data-depth') / 10;
      item.style.transform = 'translate(' + mouseX * depth + 'px, ' + mouseY * depth + 'px)'
    })
  })
};

module.exports = parallaxCursor;
